export default __webpack_public_path__ + "static/media/carousel-item-02.c3c0640f.jpg";